module.exports = __webpack_public_path__ + "static/media/refrig.c3be905e.png";